// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TransitionScene extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 936.5, y ?? 400);

    // item14Row1
    const item14Row1 = scene.add.image(1000, 302, "common", "wipe-barrel.png");
    item14Row1.scaleX = 1.1;
    item14Row1.scaleY = 1.1;
    this.add(item14Row1);

    // item13Row1
    const item13Row1 = scene.add.image(-890, 302, "common", "wipe-barrel.png");
    item13Row1.scaleX = 1.1;
    item13Row1.scaleY = 1.1;
    this.add(item13Row1);

    // item12Row1
    const item12Row1 = scene.add.image(-620, 302, "common", "wipe-barrel.png");
    item12Row1.scaleX = 1.1;
    item12Row1.scaleY = 1.1;
    this.add(item12Row1);

    // item11Row1
    const item11Row1 = scene.add.image(730, 302, "common", "wipe-barrel.png");
    item11Row1.scaleX = 1.1;
    item11Row1.scaleY = 1.1;
    this.add(item11Row1);

    // item10Row1
    const item10Row1 = scene.add.image(460, 302, "common", "wipe-barrel.png");
    item10Row1.scaleX = 1.1;
    item10Row1.scaleY = 1.1;
    this.add(item10Row1);

    // item9Row1
    const item9Row1 = scene.add.image(190, 302, "common", "wipe-barrel.png");
    item9Row1.scaleX = 1.1;
    item9Row1.scaleY = 1.1;
    this.add(item9Row1);

    // item8Row1
    const item8Row1 = scene.add.image(-80, 302, "common", "wipe-barrel.png");
    item8Row1.scaleX = 1.1;
    item8Row1.scaleY = 1.1;
    this.add(item8Row1);

    // item7Row1
    const item7Row1 = scene.add.image(-350, 302, "common", "wipe-barrel.png");
    item7Row1.scaleX = 1.1;
    item7Row1.scaleY = 1.1;
    this.add(item7Row1);

    // item_large_png_6
    const item_large_png_6 = scene.add.image(-241, 122, "common", "wipe-barrel.png");
    item_large_png_6.scaleX = 1.1;
    item_large_png_6.scaleY = 1.1;
    this.add(item_large_png_6);

    // item_large_png_5
    const item_large_png_5 = scene.add.image(29, 122, "common", "wipe-barrel.png");
    item_large_png_5.scaleX = 1.1;
    item_large_png_5.scaleY = 1.1;
    this.add(item_large_png_5);

    // item_large_png_4
    const item_large_png_4 = scene.add.image(299, 122, "common", "wipe-barrel.png");
    item_large_png_4.scaleX = 1.1;
    item_large_png_4.scaleY = 1.1;
    this.add(item_large_png_4);

    // item_large_png_3
    const item_large_png_3 = scene.add.image(569, 122, "common", "wipe-barrel.png");
    item_large_png_3.scaleX = 1.1;
    item_large_png_3.scaleY = 1.1;
    this.add(item_large_png_3);

    // item_large_png_2
    const item_large_png_2 = scene.add.image(839, 122, "common", "wipe-barrel.png");
    item_large_png_2.scaleX = 1.1;
    item_large_png_2.scaleY = 1.1;
    this.add(item_large_png_2);

    // item_large_png_1
    const item_large_png_1 = scene.add.image(-511, 122, "common", "wipe-barrel.png");
    item_large_png_1.scaleX = 1.1;
    item_large_png_1.scaleY = 1.1;
    this.add(item_large_png_1);

    // item_large_png
    const item_large_png = scene.add.image(-781, 122, "common", "wipe-barrel.png");
    item_large_png.scaleX = 1.1;
    item_large_png.scaleY = 1.1;
    this.add(item_large_png);

    // item_large_png_16
    const item_large_png_16 = scene.add.image(-883, -100, "common", "wipe-barrel.png");
    item_large_png_16.scaleX = 1.1;
    item_large_png_16.scaleY = 1.1;
    this.add(item_large_png_16);

    // item_large_png_15
    const item_large_png_15 = scene.add.image(1007, -100, "common", "wipe-barrel.png");
    item_large_png_15.scaleX = 1.1;
    item_large_png_15.scaleY = 1.1;
    this.add(item_large_png_15);

    // item_large_png_22
    const item_large_png_22 = scene.add.image(-343, -100, "common", "wipe-barrel.png");
    item_large_png_22.scaleX = 1.1;
    item_large_png_22.scaleY = 1.1;
    this.add(item_large_png_22);

    // item_large_png_21
    const item_large_png_21 = scene.add.image(-73, -100, "common", "wipe-barrel.png");
    item_large_png_21.scaleX = 1.1;
    item_large_png_21.scaleY = 1.1;
    this.add(item_large_png_21);

    // item_large_png_20
    const item_large_png_20 = scene.add.image(197, -100, "common", "wipe-barrel.png");
    item_large_png_20.scaleX = 1.1;
    item_large_png_20.scaleY = 1.1;
    this.add(item_large_png_20);

    // item_large_png_19
    const item_large_png_19 = scene.add.image(467, -100, "common", "wipe-barrel.png");
    item_large_png_19.scaleX = 1.1;
    item_large_png_19.scaleY = 1.1;
    this.add(item_large_png_19);

    // item_large_png_18
    const item_large_png_18 = scene.add.image(737, -100, "common", "wipe-barrel.png");
    item_large_png_18.scaleX = 1.1;
    item_large_png_18.scaleY = 1.1;
    this.add(item_large_png_18);

    // item_large_png_17
    const item_large_png_17 = scene.add.image(-613, -100, "common", "wipe-barrel.png");
    item_large_png_17.scaleX = 1.1;
    item_large_png_17.scaleY = 1.1;
    this.add(item_large_png_17);

    // item_large_png_29
    const item_large_png_29 = scene.add.image(-474, -318, "common", "wipe-barrel.png");
    item_large_png_29.scaleX = 1.1;
    item_large_png_29.scaleY = 1.1;
    this.add(item_large_png_29);

    // item_large_png_28
    const item_large_png_28 = scene.add.image(876, -318, "common", "wipe-barrel.png");
    item_large_png_28.scaleX = 1.1;
    item_large_png_28.scaleY = 1.1;
    this.add(item_large_png_28);

    // item_large_png_27
    const item_large_png_27 = scene.add.image(606, -318, "common", "wipe-barrel.png");
    item_large_png_27.scaleX = 1.1;
    item_large_png_27.scaleY = 1.1;
    this.add(item_large_png_27);

    // item_large_png_26
    const item_large_png_26 = scene.add.image(336, -318, "common", "wipe-barrel.png");
    item_large_png_26.scaleX = 1.1;
    item_large_png_26.scaleY = 1.1;
    this.add(item_large_png_26);

    // item_large_png_25
    const item_large_png_25 = scene.add.image(66, -318, "common", "wipe-barrel.png");
    item_large_png_25.scaleX = 1.1;
    item_large_png_25.scaleY = 1.1;
    this.add(item_large_png_25);

    // item_large_png_24
    const item_large_png_24 = scene.add.image(-204, -318, "common", "wipe-barrel.png");
    item_large_png_24.scaleX = 1.1;
    item_large_png_24.scaleY = 1.1;
    this.add(item_large_png_24);

    // item_large_png_23
    const item_large_png_23 = scene.add.image(-744, -319, "common", "wipe-barrel.png");
    item_large_png_23.scaleX = 1.1;
    item_large_png_23.scaleY = 1.1;
    this.add(item_large_png_23);

    // item_large_png_7
    const item_large_png_7 = scene.add.image(-1014, -319, "common", "wipe-barrel.png");
    item_large_png_7.scaleX = 1.1;
    item_large_png_7.scaleY = 1.1;
    this.add(item_large_png_7);

    // lists
    const items = [item_large_png_7, item_large_png_23, item_large_png_24, item_large_png_25, item_large_png_26, item_large_png_27, item_large_png_28, item_large_png_29, item_large_png_17, item_large_png_18, item_large_png_19, item_large_png_20, item_large_png_21, item_large_png_22, item_large_png_15, item_large_png_16, item_large_png, item_large_png_1, item_large_png_2, item_large_png_3, item_large_png_4, item_large_png_5, item_large_png_6, item7Row1, item8Row1, item9Row1, item10Row1, item11Row1, item12Row1, item13Row1, item14Row1];

    this.items = items;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private items: Phaser.GameObjects.Image[];

  /* START-USER-CODE */

  private coveredCallback: (() => void) | undefined;
  private doneCallback: (() => void) | undefined;

  public activate(coveredCallback?: () => void, doneCallback?: () => void) {
    if (coveredCallback) this.coveredCallback = coveredCallback;
    if (doneCallback) this.doneCallback = doneCallback;

    this.transitionIn();
    this.scene.time.delayedCall(1000, this.transitionOut, [], this);
    if (this.doneCallback) this.scene.time.delayedCall(500, this.doneCallback);
  }

  public show(onComplete?: () => void) {
    this.transitionInInit();
    this.transitionIn(onComplete);
  }

  public hide(onComplete?: () => void) {
    this.transitionOut(onComplete);
  }

  public reset() {
    this.transitionInInit();
  }

  protected init() {
    this.items.forEach((item) => {
      item.y -= 1000;
    });
  }

  transitionInInit() {
    this.items.forEach((item) => {
      item.y -= 1000;
    });
  }

  transitionIn(onComplete?: () => void) {
    let itemDuration = 100;
    let count = this.items.length - 1;
    this.scene.add.tween({
      targets: this,
      x: this.x,
      duration: 25,
      repeat: this.items.length,
      onRepeat: () => {
        this.scene.add.tween({
          targets: this.items[count],
          y: '+=1000',
          duration: itemDuration,
          ease: Phaser.Math.Easing.Cubic.Out
        });
        count--;
      },
      onComplete: onComplete
    });
  }

  transitionOut(onComplete?: () => void) {
    this.coveredCallback?.();

    let itemDuration = 100;
    let count = 0;
    this.scene.add.tween({
      targets: this,
      x: this.x,
      duration: 25,
      repeat: this.items.length,
      onRepeat: () => {
        this.scene.add.tween({
          targets: this.items[count],
          y: '-=1000',
          duration: itemDuration,
          ease: Phaser.Math.Easing.Cubic.In
        });
        count++;
      },
      onComplete: onComplete
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
